<template>
    <div v-if="items.length" class="about-list">
        <h2 class="type">{{type | programTypeKo}}</h2>
        <ul class="list">
            <li v-for="item in items" :key="item.id" class="item">{{item.name}}</li>
        </ul>
    </div>
</template>

<script>
import { programTypeKo } from '@/core/type'
import { store } from '@/stores'
import { getters } from '@/stores/programs'

export default {
    name: 'AboutList',
    filters: {
        programTypeKo
    },
    props: {
        type: null,
        secondWave: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        items() {
            return this.secondWave
                ? store.getters[getters.secondWave].filter(x => x.type === this.type)
                : store.getters[getters.firstWave].filter(x => x.type === this.type)
        }
    },
}
</script>

<style scoped lang="scss">
@import '~@/styles/_parts';

.about-list {
    display: flex;
    font-size: em(15);
    line-height: 2;
}
.type {
    width: 60px;
    min-width: 60px;
    flex-shrink: 0;
    font-weight: 800;
}
.list {
    padding-left: 23px;
}
.item {
    line-height: 1.4;
    word-break: keep-all;
    & + & {
        margin-top: 1em;
    }
}
</style>